export default __webpack_public_path__ + "static/media/Mark-2-Blueprints-00.86220b37.jpg";